export default class RemoveUserFromGroupsTask {
  static InProgress = (id: string) => {
    return {
      id,
      title: "Remove user from groups",
    };
  };
}
